export default __webpack_public_path__ + "static/media/button.5b3c163d.svg";